import { getUniversalEnv } from 'app/lib/get-universal-env';

// https://confluence.tennisi.it/pages/viewpage.action?pageId=809992312
type AvailableSizes = 20 | 24 | 48 | 50 | 54 | 66 | 72 | 100;
type CDNName = 'STORAGE_CLOUD_URL' | 'CDN_FOR_TOURNAMENT_ICONS_URL';
type Extension = 'png' | 'webp';

const getIconPatchWithRequiredExt = (iconPath: string, ext: string) => {
  if (iconPath.includes(ext)) {
    return iconPath;
  }

  const hasExtIconPath = iconPath.includes('.png');

  if (hasExtIconPath) {
    return iconPath.replace('.png', `.${ext}`);
  }

  return `${iconPath}.${ext}`;
};

export const getImageUrlFromCdn = (
  iconPath?: string,
  size?: AvailableSizes,
  ext: Extension = 'webp',
  cdnName: CDNName = 'STORAGE_CLOUD_URL',
): string => {
  if (!iconPath) {
    return '';
  }

  const domain = getUniversalEnv(cdnName);
  const iconPathWithExt = getIconPatchWithRequiredExt(iconPath, ext);

  if (size) {
    return `${domain}/${size}/${iconPathWithExt}`;
  }

  return `${domain}/${iconPathWithExt}`;
};
